module.exports = __webpack_public_path__ + "img/7.7c63a99e.png";